import type { ApiResponse } from '@bcube/shared';
import { api } from '@/lib/api';
export type FinancialObligationStatus =
  | 'PENDING_PAYMENT'
  | 'PENDING_VALIDATION'
  | 'APPROVED'
  | 'CANCELED'
  | 'INTEGRATION_RETRY';
export interface PaymentConfirmationObligation {
  obligationId: string;
  proposalId: string;
  proposalSeq: number;
  clientName: string;
  method: 'PIX' | 'BOLETO';
  status: FinancialObligationStatus;
  amountInCents: number;
  createdAt: string;
  updatedAt: string;
  receiptId: string | null;
  receiptOriginalName: string | null;
}
export const financialObligationApi = {
  findPaymentConfirmations: async (
    params: { pendingOnly?: boolean; page?: number; limit?: number } = {},
  ) =>
    (
      await api.get<ApiResponse<PaymentConfirmationObligation[]>>(
        '/commercial/financial-obligations',
        { params },
      )
    ).data.data,
  cancel: async (id: string, reason: string) =>
    (
      await api.post<ApiResponse<unknown>>(`/commercial/financial-obligations/${id}/cancel`, {
        reason,
      })
    ).data.data,
  getReceiptDownloadUrl: async (id: string) =>
    (await api.get<ApiResponse<{ url: string }>>(`/commercial/financial-obligations/${id}/receipt`))
      .data.data,
  approve: async (id: string) =>
    (await api.post<ApiResponse<unknown>>(`/commercial/financial-obligations/${id}/approve`)).data
      .data,
};
